// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isCustomObjectApiItem = objectOf({
  type_name: string,
  external_id: string,
  attributes: objectOf({}),
});

export const isGetCustomObjectsTypeNameExternalIdResult = objectOf({
  custom_objects: arrayOf(isCustomObjectApiItem),
});
